import { useNavigate } from 'react-router-dom';
import { ProfileEditPage, mapMeToProfileData } from '@practium/features/profile';
import { useToast } from '@practium/ui';
import { useGetMe, useUpdateProfile, useRequestAnonymization, useRequestDataExport } from '@practium/features/api';
import { useAuth } from '@practium/features/auth';
import { ProfileEditData } from '../../../../../../packages/features/profile/schemas/profile.schema';

export const ProfileEditPageAdmin = () => {
	const navigate = useNavigate();
	const toast = useToast();
	const { logout } = useAuth();

	const { data: me, isLoading } = useGetMe();
	const { mutateAsync: updateProfile } = useUpdateProfile();
	const { mutateAsync: requestAnonymization } = useRequestAnonymization();
	const { mutateAsync: requestDataExport } = useRequestDataExport();

	const handleSave = async (data: ProfileEditData) => {
		try {
			await updateProfile({
				formData: data.formData,
				avatarFile: data.avatarFile,
				backgroundFile: data.backgroundFile,
			});
			toast.success('Perfil atualizado com sucesso!');
			navigate('/perfil');
		} catch (error) {
			toast.error('Erro ao atualizar perfil. Tente novamente.');
			throw error;
		}
	};

	const handleChangePassword = async (_currentPassword: string, newPassword: string) => {
		try {
			await updateProfile({ password: newPassword, confirmPassword: newPassword });
			toast.success('Senha alterada com sucesso!');
		} catch (error) {
			toast.error('Erro ao alterar senha. Tente novamente.');
			throw error;
		}
	};

	const handleExportData = async () => {
		try {
			await requestDataExport();
			toast.success(
				'Solicitação enviada! Você receberá um e-mail com o link para download em breve.'
			);
		} catch (error) {
			toast.error('Erro ao solicitar exportação. Tente novamente.');
			throw error;
		}
	};

	const handleDeleteAccount = async () => {
		if (me?.isMaster) {
			toast.error('A conta master não pode ser excluída por aqui.');
			return;
		}
		if (!me?._id) {
			toast.error('Não foi possível identificar a conta. Tente novamente.');
			return;
		}
		try {
			const result = await requestAnonymization(me._id);
			toast.success(
				result.message ||
					'Solicitação registrada. Sua conta foi bloqueada e será excluída após o prazo de carência.'
			);
			await logout();
			navigate('/login', { replace: true });
		} catch (error) {
			toast.error(
				error instanceof Error ? error.message : 'Erro ao solicitar exclusão da conta. Tente novamente.'
			);
			throw error;
		}
	};

	return (
		<ProfileEditPage
			data={me ? mapMeToProfileData(me) : null}
			isLoading={isLoading}
			onSave={handleSave}
			onChangePassword={handleChangePassword}
			onExportData={handleExportData}
			onDeleteAccount={handleDeleteAccount}
		/>
	);
};
